import type { ChangeEvent, ComponentType } from 'react'

import { FormControl, type IFormikFormControlProps } from './FormControl'
import { Checkbox, type ICheckboxProps } from '../../elements/Checkbox/'

interface IFormCheckboxProps
  extends
    Pick<
      IFormikFormControlProps,
      Exclude<keyof IFormikFormControlProps, 'children'>
    >,
    ICheckboxProps {
  id: string
  name: string
  /** Unique identifier for analytics tracking of checkbox interactions. */
  analyticsId?: string
}

export const createOnChangeHandler =
  (handleChange: any) => (e: ChangeEvent<HTMLInputElement>) => {
    e.persist()
    handleChange(e.target.checked)
  }

export const FormCheckbox: ComponentType<IFormCheckboxProps> = (props) => {
  const {
    name,
    disabled,
    id,
    label,
    helperText,
    required,
    fullWidth,
    ...checkboxProps
  } = props
  return (
    <FormControl
      name={name}
      disabled={disabled}
      id={id}
      label={label}
      helperText={helperText}
      required={required}
      fullWidth={fullWidth}
    >
      {({ value, handleChange, isSubmitting }) => (
        <Checkbox
          {...checkboxProps}
          id={id}
          disabled={isSubmitting || disabled}
          checked={value}
          onChange={createOnChangeHandler(handleChange)}
        />
      )}
    </FormControl>
  )
}
FormCheckbox.displayName = 'Form.Checkbox'
